
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.20716 8L8.05112 11.714C8.35926 12.0081 8.35926 12.4854 8.05112 12.7795C7.74298 13.0735 7.24282 13.0735 6.93468 12.7795L2.50049 8.50218C2.20947 8.22445 2.20947 7.77484 2.50049 7.49782L6.93468 3.22055C7.24282 2.92649 7.74298 2.92649 8.05112 3.22055C8.35926 3.51461 8.35926 3.99192 8.05112 4.28598L4.20716 8Z","fill":"#10001F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.65638 8L13.5003 11.714C13.8085 12.0081 13.8085 12.4854 13.5003 12.7795C13.1922 13.0735 12.692 13.0735 12.3839 12.7795L7.94971 8.50218C7.65869 8.22445 7.65869 7.77484 7.94971 7.49782L12.3839 3.22055C12.692 2.92649 13.1922 2.92649 13.5003 3.22055C13.8085 3.51461 13.8085 3.99192 13.5003 4.28598L9.65638 8Z","fill":"#10001F"}})])
          )
        }
      }
    